import SetUpDeliveries from './set-up-deliveries';

export default SetUpDeliveries;
